import React, { useState } from 'react'
import './carousel.scss'
import { StoreSlide1, StoreSlide2, StoreSlide3, StoreSlide4, StoreSlide5, StoreSlide6, StoreSlide7 } from '../../../icon/icons';
import { Container, Row, Col, Carousel, NavLink } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const CarouselMain = ({showSeemore=false , id}) => {

    const carouselData = [
        {
            id: 1,
            imageComponent: <StoreSlide1 />,
            title: 'DIRECT WRITER',
            heading: 'Timely support during critical times',
            description:
                'Sentry works efficiently to help Spectra Print recover from fire and subsequent business interruption.',
            link: '',
        },
        {
            id: 2,
            imageComponent: <StoreSlide2 />,
            title: 'REGIONAL',
            heading: 'Cultivating a culture of safety',
            description:
                'Safety is a No. 1 priority at Greenbrier Lawn and Tree Expert Co. The landscaping firm works closely with Sentry to ensure its safety culture remains strong.',
            link: '',
        },
        {
            id: 3,
            imageComponent: <StoreSlide3 />,
            title: 'TRUCKING',
            heading: 'Insuring for the long haul',
            description:
                'The long-term relationship between Huff and Puff Trucking and Sentry is built on reliability and trust.',
            link: '',
        },
        {
            id: 4,
            imageComponent: <StoreSlide4 />,
            title: 'DEALERSHIPS',
            heading: 'Building trust in a new community',
            description:
                'When LandMark Implement experienced a large fire at their newly acquired shop, getting their new employees back to work quickly was their top priority.',
            link: '',
        },
        {
            id: 5,
            imageComponent: <StoreSlide5 />,
            title: 'DEALERSHIPS',
            heading: 'Recovering quickly from a devastating tornado',
            description:
                'While others struggled to rebuild in the wake of a tornado, Barry Grossenburg was up and running within days and doing business from a new facility in a year.',
            link: '',
        },
        {
            id: 6,
            imageComponent: <StoreSlide6 />,
            title: 'METALWORKING',
            heading: 'Harrison Machine & Welding offers a personal touch',
            description:
                'Small businesses rely on personal touch as a factor in keeping customers. The same thing holds true for Sentry in providing insurance solutions for small businesses.',
            link: '',
        },
        {
            id: 7,
            imageComponent: <StoreSlide7 />,
            title: 'WORKERS COMPENSATION',
            heading: 'A joint approach to managing claims',
            description:
                'At Sentry, we work closely with customers like Green Bay Packaging to help determine the best outcome for workers’ compensation claims.',
            link: '',
        },
    ];
    return (
        <section className='success-stories' id={id}>
            <div className='common-heading'>
                <h2>Our customer success stories</h2>
                {showSeemore &&
                    <Link to="">See other stories {'>'}</Link>
                }
            </div>
            <Carousel>
                {carouselData.map((slide) => (
                    <Carousel.Item key={slide.id}>
                        <Row>
                            <Col sm={12} md={6} lg={7} xl={7}>
                                <div className="left-slide-img">{slide.imageComponent}</div>
                            </Col>
                            <Col sm={12} md={6} lg={5} xl={5} className="right-content-wrapper">
                                <Carousel.Caption>
                                    <h3>{slide.title}</h3>
                                    <h1>{slide.heading}</h1>
                                    <p>{slide.description}</p>
                                    <NavLink to={slide.link}>Read story</NavLink>
                                </Carousel.Caption>
                            </Col>
                        </Row>
                    </Carousel.Item>
                ))}
            </Carousel>
        </section>
    )
}

export default CarouselMain